import type {
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { catchError, from, switchMap, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return throwError(() => error);
      }

      if (error.error instanceof Blob) {
        return from(error.error.text()).pipe(
          switchMap((text) => {
            const errorMsg = text ? JSON.parse(text).message : null;
            return throwError(() => new Error(errorMsg));
          }),
        );
      }

      return throwError(() => error.error?.message || error.message || error);
    }),
  );
};
